import * as React from 'react';

import { createStore, useStore } from 'zustand';

export interface ProductSectionsState {
  isRoutineDisplayed: boolean;
  displayedRelatedProductIds: number[];
  actions: {
    setRoutineDisplayed: (isDisplayed: boolean) => void;
    setDisplayedRelatedProductIds: (ids: number[]) => void;
  };
}

export type ProductSectionsStore = ReturnType<
  typeof createProductSectionsStore
>;

export const createProductSectionsStore = () =>
  createStore<ProductSectionsState>((set) => ({
    isRoutineDisplayed: false,
    displayedRelatedProductIds: [],
    actions: {
      setRoutineDisplayed: (isDisplayed) =>
        set({ isRoutineDisplayed: isDisplayed }),
      setDisplayedRelatedProductIds: (ids) =>
        set({ displayedRelatedProductIds: ids }),
    },
  }));

const ProductSectionsStoreContext =
  React.createContext<ProductSectionsStore | null>(null);

export const ProductSectionsStoreContextProvider =
  ProductSectionsStoreContext.Provider;

const useProductSectionsStore = () => {
  const store = React.useContext(ProductSectionsStoreContext);
  if (!store) {
    throw new Error(
      'useProductSectionsStore must be used within ProductSectionsStoreContext.Provider'
    );
  }
  return store;
};

export const useProductSectionsStateInfo = <T = ProductSectionsState>(
  selector?: (state: ProductSectionsState) => T
): T => {
  const store = useProductSectionsStore();
  return useStore(store, selector ?? ((state) => state as unknown as T));
};
